import { InfoIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { User } from "@/lib/types";
import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { request } from "@/lib/request";

export const UserEmail = ({ user }: { user: User }) => {
  const [loading, setLoading] = useState(false);
  const [disableTimeout, setDisableTimeout] = useState(false);
  const timerRef = useRef<number | null>(null);

  const handleRequest = async () => {
    setLoading(true);
    try {
      await request.post(`/auth/request-verification-email`).catch(err => {
        throw new Error(
          err.response?.data.message
            ? err.response?.data.message
            : "Something went wrong, please try again.",
        );
      });

      toast.success("Request submitted", {
        description: "Please check your email for further instructions.",
      });
      setDisableTimeout(true);
      timerRef.current = window.setTimeout(
        () => {
          setDisableTimeout(false);
        },
        1 * 60 * 1000,
      );
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="flex items-center justify-between">
        <span className="text-sm font-bold">Email Address</span>
        <p className="flex items-center text-sm text-muted-foreground">
          {user.isActive ? null : (
            <InfoIcon className="me-1 size-4 text-red-500" />
          )}
          {user.email}
        </p>
      </div>
      {user.isActive ? null : (
        <>
          <p className="text-xs text-red-500">
            This email address is not verified. If you have not received
            verification email, you can request one by clicking{" "}
            <Button
              variant="link"
              size="sm"
              className="px-1"
              onClick={handleRequest}
              disabled={disableTimeout || loading}
            >
              here
            </Button>
            .
          </p>
        </>
      )}
    </>
  );
};
